// Clerk roles are defined in Clerk's dashboard.
// Pulled into currentUser in api/src/lib/auth.ts
// Accessed in the API via context.currentUser
// Accessed in the web via useAuth().currentUser

export enum ClerkRole {
  Admin = 'org:admin',
  Member = 'org:member',
  Customer = 'org:customer',
  Grower = 'org:grower',
}

export function getRoleDisplayName(role: ClerkRole | string): string {
  switch (role) {
    case ClerkRole.Admin:
      return 'Admin';
    case ClerkRole.Member:
      return 'Member';
    case ClerkRole.Customer:
      return 'Customer';
    case ClerkRole.Grower:
      return 'Grower';
    default:
      // Clerk roles often prefix with `org:<role>`
      return role.replace('org:', '');
  }
}
